<template>
    
    <section class="bg-nomad-sky px-6 pb-20 pt-16 text-nomad-primary sm:pb-28 sm:pt-20">
        <div class="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
            <div>
                <p class="w-fit rounded-full border border-nomad-primary/15 bg-white/45 px-3 py-1 text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-primary/70">Selected work</p>
                <h1 class="mt-6 max-w-3xl text-5xl font-extrabold leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl">Work that turns vision into momentum.</h1>
                <p class="mt-6 max-w-2xl text-lg leading-relaxed text-nomad-primary/75 sm:text-xl">A selection of digital products, platforms, and experiences built to solve real business problems.</p>
            </div>
            <div class="flex justify-center lg:justify-end">
                <img src="/assets/images/screen-discover-wire-blank.svg" class="w-full max-w-[34rem] rounded-[1.5rem] p-2 shadow-[0_1rem_2.5rem_rgba(42,38,64,0.1)]" alt="Digital product project preview">
            </div>
        </div>
    </section>
    <Container class="flex flex-col gap-8">
        <ProjectPreview v-for="project in projects" :key="project.id" :name="project.name" :description="project.description" :image="project.image" :color="project.color" :text-color="project.textColor" :stats="project.stats" :url="project.url" />
    </Container>
    <Container>
        <C2a title="Hourly Support Subscription" subtitle="Access Dedicated Assistance and Support at an Average Rate of $72.8 This Year" cta="Pay now" url="/" />
    </Container>
</template>
<script>
import C2a from '@/components/C2a.vue';
import Container from '@/layouts/Container.vue';
import ProjectPreview from '@/components/ProjectPreview.vue';
export default {
    components: {
    C2a,
    Container,
    ProjectPreview
},
    data() {
        return {
            contents: [
                {
                    id: 1,
                    title: 'Research & planing',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    icon: '/assets/icons/star.svg'
                },
                {
                    id: 2,
                    title: 'Design & Development',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    icon: '/assets/icons/code.svg'
                },
                {
                    id: 3,
                    title: 'SEO & Marketing',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    icon: '/assets/icons/zap-off.svg'
                }
            ],
            projects: [
            {
                    id: 1,
                    name: 'Flex Cleaning Service',
                    description: "Flex Cleaning's transformation journey includes a modern website, data insights, and targeted reach. We crafted a website that reflects their professionalism and implemented data tools for strategic decisions. Our targeted reach system maximizes their online presence.",
                    color: '#D6D3E2',
                    url: '',
                    image: '/assets/images/screen-fc.png',
                    stats: [{number: '5x', context: 'branches'}, {number: '700K', context: 'transactions'}]
                },
                {
                    id: 2,
                    name: 'Horn Daily',
                    description: "We're proud to present Horn Daily's Arabic website, a portal that delivers the latest news, stories, and updates to Arabic-speaking audiences. Our website design ensures a seamless reading experience, offering comprehensive news coverage in a visually appealing and culturally sensitive format.",
                    color: '#D5CB97',
                    url: '',
                    image: '/assets/images/screen-hd.png',
                    stats: [{number: '200k', context: 'articles'}, {number: '150K', context: 'visits'}]
                },
                {
                    id: 3,
                    name: 'Nomad Lyrics',
                    description: "Horn Daily's digital journey mirrors Nomad Lyrics in its multifaceted approach. Our work spans a visually captivating Arabic website, engaging newsletters, and a seamless podcast feed system. Discover news, stay informed with newsletters, and enjoy audio content. Horn Daily is your holistic digital source.",
                    color: '#97D5B4',
                    url: '',
                    image: '/assets/images/screen-discover.png',
                    stats: [{number: '1.2M', context: 'streams'}, {number: '100K', context: 'visits'}]
                }
            ]
        }
    }
}
</script>